module.exports = __webpack_public_path__ + "img/phones3.0592897.jpg";